import * as CryptoJS from 'crypto-js';
let cv = '';
function generateRandomString(length:any) {
  let text = '';
  const codeVerifier = sessionStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(((Date.now() * i) * Date.now() + Date.now()) % possible.length);
    }
    cv = text;
    sessionStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier:any) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallange + '&code_challenge_method=S256';
}

function base64URL(value: any) {
  return value.toString(CryptoJS.enc.Base64).replaceAll('=', '').replaceAll('+', '-').replaceAll('/', '_');
}

export const logindetails = {
  codeVerifier: generateRandomString(128),
  codeChallenge: generateCodeChallenge(cv)
};